import { Form } from 'antd'
import Button from 'components/Button/index'
import Drawer from 'components/Drawer'
import ErrorMessage from 'components/UIComponents/MessagePopup/ErrorMessage'
import { getInterviewerList } from 'modules/Drives/actions'
import InterviewForm from 'modules/Exp-Candidates/ViewDriveRole/BulkActionDrawer/ScheduleInterviewDrawer/InterviewForm'
import ManyToManyPreview from 'modules/Exp-Candidates/ViewDriveRole/BulkActionDrawer/ScheduleInterviewDrawer/ManyToManyPreview/index'
import OneToOnePreview from 'modules/Exp-Candidates/ViewDriveRole/BulkActionDrawer/ScheduleInterviewDrawer/OneToOnePreview/index'
import { FooterFlex } from 'modules/Exp-Candidates/ViewDriveRole/BulkActionDrawer/ScheduleInterviewDrawer/style'
import {
  getNotificationCatalogues,
  sendAssessmentWhatsapp,
  sendNotificationBulkEmail,
  sendNotificationBulkEmailWhatsapp,
} from 'modules/Users/actions'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import SuccessMessage from 'utils/SuccessMessage'
import { permittedEventCruds } from 'utils/permissionsValidation'
import { toCamelCase } from '../../../../../utils/camelCase'

const ScheduleInterview = ({
  scheduleDrawer,
  setScheduleDrawer,
  selectedCandidateId,
  selectedCandidate,
  rolesMetrics,
  createInterview,
  driveId,
  roleId,
  driveInterViewerList,
  getDriveInterviewerList,
  selectedRound,
  driveData,
  selectedRoundType,
  candidateDeatils,
  candidateInfoData,
  getCandidateList,
  getRoleMetrics,
  setSelectedCandidateId,
  setSelectedCandidate,
  isSingleOrBulk,
}) => {
  const [form] = Form.useForm()
  const { AUTH_URL } = process.env
  const dispatch = new useDispatch()
  const [preview, setPreview] = useState(false)
  const [schedulePreview, setSchedulePreview] = useState(false)

  const [candidates, setCandidates] = useState(0)
  const [selectedRoundName, setSelectedRoundName] = useState(selectedRound)
  const [interviewType, setInterviewType] = useState('')
  const [interviewMode, setInterviewMode] = useState(null)
  const [isOneDayDrive, setIsOneDayDrive] = useState(
    driveData?.startDate === driveData?.endDate
  )
  const [linkPanelData, setLinkPanelData] = useState([
    {
      link: '',
      panel: [{ id: null, firstName: null, lastName: null }],
    },
  ])
  const [addedInterviewer, setAddedInterviewer] = useState([])

  const [interviewInfo, setInterviewInfo] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [confirmedResponse, setConfirmedResponse] = useState({})
  const [interviewdate, setInterviewdate] = useState([])
  const [parametersList, setParametersList] = useState([])

  const [selectingStartDate, setSelectingStartDate] = useState('')
  const [selectingEndDate, setSelectingEndDate] = useState('')
  const [dateRange, setDateRange] = useState([])
  const interviewListData = useSelector(state => state?.drives?.interViewerList)

  const [interviewList, setInterviewList] = useState(interviewListData)
  const order = rolesMetrics[0]?.rounds
    ?.map(({ roundName }) => roundName)
    .indexOf(selectedRoundType?.roundName)

  const isAssesemntType =
    order === 0 && rolesMetrics[0]?.rounds[0]?.type === 'ASSESMENT'

  const dateFormat = 'YYYY-MM-DD'

  const permission = useSelector(state => state?.auth?.permissions)
  const corporateData = useSelector(state => state?.auth?.corporateData)
  const [scheduleTemplate, setScheduleTemplate] = useState(null)
  const [scheduleOfflineTemplate, setScheduleOfflineTemplate] = useState(null)
  const [interviewTemplate, setInterviewTemplate] = useState(null)
  const [assessmentWhatsapp, setAssessmentWhatsapp] = useState(null)
  const [interviewVirtualWhatsapp, setInterviewVirtualWhatsapp] = useState(null)
  const [interviewCampusWhatsapp, setInterviewCampusWhatsapp] = useState(null)
  const [assessmentOfflineWhatsapp, setAssessmentOfflineWhatsapp] =
    useState(null)
  const permittedEvents = permittedEventCruds(
    permission,
    'Evaluation Process - Fresher'
  )
  const Schedule =
    permittedEvents?.find(item => item.events?.eventName === 'VIEW')?.events ||
    ''

  useEffect(() => {
    ;(async () => {
      if (Schedule?.id) {
        let responce = await dispatch(getNotificationCatalogues(Schedule?.id))
        const filteredArray = responce?.CatalogueData?.filter(
          item =>
            item.eventNotificationTemplate &&
            item.eventNotificationTemplate.templateName ===
              'Assessment Scheduled Online' &&
            item.eventNotificationTemplate.eventNotificationType &&
            item.eventNotificationTemplate.eventNotificationType.name ===
              'E-Mail'
        )

        if (filteredArray?.length > 0) {
          setScheduleTemplate(filteredArray[0].eventNotificationTemplate)
        }

        const filteredArray1 = responce?.CatalogueData?.filter(
          item =>
            item.eventNotificationTemplate &&
            item.eventNotificationTemplate.templateName ===
              'Interview Scheduled' &&
            item.eventNotificationTemplate.eventNotificationType &&
            item.eventNotificationTemplate.eventNotificationType.name ===
              'E-Mail'
        )

        if (filteredArray1?.length > 0) {
          setInterviewTemplate(filteredArray1[0].eventNotificationTemplate)
        }

        const filteredArray2 = responce?.CatalogueData?.filter(
          item =>
            item.eventNotificationTemplate &&
            item.eventNotificationTemplate.templateName ===
              'assessment_scheduled_student' &&
            item.eventNotificationTemplate.eventNotificationType &&
            item.eventNotificationTemplate.eventNotificationType.name ===
              'WhatsApp'
        )

        if (filteredArray2?.length > 0) {
          setAssessmentWhatsapp(filteredArray2[0].eventNotificationTemplate)
        }

        const filteredArray3 = responce?.CatalogueData?.filter(
          item =>
            item.eventNotificationTemplate &&
            item.eventNotificationTemplate.templateName ===
              'interview_scheduled__virtual_' &&
            item.eventNotificationTemplate.eventNotificationType &&
            item.eventNotificationTemplate.eventNotificationType.name ===
              'WhatsApp'
        )

        if (filteredArray3?.length > 0) {
          setInterviewVirtualWhatsapp(
            filteredArray3[0].eventNotificationTemplate
          )
        }

        const filteredArray4 = responce?.CatalogueData?.filter(
          item =>
            item.eventNotificationTemplate &&
            item.eventNotificationTemplate.templateName ===
              'interview_scheduled__campus_and_pool_drive' &&
            item.eventNotificationTemplate.eventNotificationType &&
            item.eventNotificationTemplate.eventNotificationType.name ===
              'WhatsApp'
        )

        if (filteredArray4?.length > 0) {
          setInterviewCampusWhatsapp(
            filteredArray4[0].eventNotificationTemplate
          )
        }

        const filteredArray5 = responce?.CatalogueData?.filter(
          item =>
            item.eventNotificationTemplate &&
            item.eventNotificationTemplate.templateName ===
              'assessment_scheduled_student_offline' &&
            item.eventNotificationTemplate.eventNotificationType &&
            item.eventNotificationTemplate.eventNotificationType.name ===
              'WhatsApp'
        )

        if (filteredArray5?.length > 0) {
          setAssessmentOfflineWhatsapp(
            filteredArray5[0].eventNotificationTemplate
          )
        }
        const filteredArray6 = responce?.CatalogueData?.filter(
          item =>
            item.eventNotificationTemplate &&
            item.eventNotificationTemplate.templateName ===
              'Assessment Scheduled Offline' &&
            item.eventNotificationTemplate.eventNotificationType &&
            item.eventNotificationTemplate.eventNotificationType.name ===
              'E-Mail'
        )

        if (filteredArray6?.length > 0) {
          setScheduleOfflineTemplate(
            filteredArray6[0].eventNotificationTemplate
          )
        }
      }
    })()

    return () => {}
  }, [Schedule])

  useEffect(() => {
    ;(async () => {
      await dispatch(getInterviewerList())
    })()

    return () => {}
  }, [])

  const handleIterviewRound = value => {
    setSelectedRoundName(value)
    form.setFieldsValue({
      interviewRound: value,
    })
  }

  const disabledDate = current => {
    let startDate = moment(driveData?.startDate).format(dateFormat)
    let endDate = moment(driveData?.endDate).format(dateFormat)

    return (
      current < moment().subtract(1, 'days') ||
      current < moment(startDate) ||
      current > moment(endDate).endOf('day')
    )
  }

  const disabledStartDate = current => {
    let assesmentStartDate = moment(driveData?.startDate)
      .subtract(1, 'months')
      .format(dateFormat)
    let endDate = moment(driveData?.endDate).format(dateFormat)
    return (
      current < moment().subtract(1, 'days') ||
      current < moment(assesmentStartDate) ||
      current > moment(endDate).endOf('day')
    )
  }

  const disabledEndDate = current => {
    let selectedStartDate = moment(selectingStartDate, 'DD/MM/YYYY').format(
      dateFormat
    )

    return (
      current < moment().subtract(1, 'days') ||
      current < moment(selectedStartDate)
    )
  }

  const onChangeStartDate = (date, dateString) => {
    setSelectingStartDate(dateString)
    form.setFieldsValue({
      startDate: moment(dateString, 'DD/MM/YYYY'),
    })
  }

  const onChangeEndDate = (date, dateString) => {
    setSelectingEndDate(dateString)
    form.setFieldsValue({
      endDate: moment(dateString, 'DD/MM/YYYY'),
    })
  }

  const onChangeDate = (date, dateString) => {
    setDateRange(date)
    form.setFieldsValue({
      dates: dateString,
    })
  }

  const onDurationChange = value => {
    form.setFieldsValue({
      duration: value,
    })
  }

  const onTimeChange = (value, time) => {
    form.setFieldsValue({
      time: time,
    })
  }

  const onChangeMode = value => {
    form.setFieldsValue({
      mode: value,
    })
    setInterviewMode(value)
  }

  const onChangeLink = (e, index) => {
    let linkAndPanel = linkPanelData
    linkAndPanel[index].link = e.target.value
    setLinkPanelData(linkAndPanel)
    form.setFieldsValue({
      linkAndPanel: linkAndPanel,
    })
  }

  const onClickNone = () => {
    setAddedInterviewer('None')
    setLinkPanelData([
      {
        panel: [{ id: null, firstName: null, lastName: null }],
      },
    ])
    form.setFieldsValue({
      linkAndPanel: [
        {
          panel: [{ id: null, firstName: null, lastName: null }],
        },
      ],
    })
  }

  const getUpdatedList = () => {
    let selectedInterviewer = linkPanelData
      ?.map(({ panel }) => panel)
      .flatMap(data => data)
      ?.map(({ id }) => id)
    let updatedInterviewerList = interviewListData.filter(
      data => !selectedInterviewer.includes(data?._id)
    )
    setInterviewList(updatedInterviewerList)
  }

  const onSelectInterview = (value, option, index) => {
    let selectedValue = Array.isArray(value) ? value : [value]
    let selectedOption = Array.isArray(option) ? option : [option]
    setAddedInterviewer(
      selectedValue.filter(item => {
        return item !== 'None'
      })
    )

    let selectedData = selectedOption?.map(({ id, firstName, lastName }) => {
      return { id, firstName, lastName }
    })
    let linkAndPanel = linkPanelData.map((data, indx) => {
      if (index === indx) {
        return { ...data, panel: selectedData }
      } else {
        return data
      }
    })

    setLinkPanelData(linkAndPanel)
    form.setFieldsValue({
      linkAndPanel: linkAndPanel,
    })
  }

  const handlePreview = () => {
    if (
      interviewType === 'GROUP' ||
      (interviewType === 'FACE_TO_FACE' && isSingleOrBulk)
    ) {
      setSchedulePreview(true)
    } else {
      setPreview(true)
    }
  }

  useEffect(() => {
    getDriveInterviewerList(driveId)
  }, [driveId])

  useEffect(() => {
    setSelectedRoundName(
      selectedRound === 'all_candidates'
        ? candidateInfoData?.stage
        : selectedRound
    )
    form.setFieldsValue({
      interviewRound:
        selectedRound === 'all_candidates'
          ? candidateInfoData?.stage
          : selectedRound,
    })
  }, [selectedRound, candidateInfoData])

  const getMode = () => {
    setIsOneDayDrive(driveData?.startDate === driveData?.endDate)
    form.setFieldsValue({
      dates: moment(driveData?.startDate, dateFormat),
    })
    if (interviewType === 'EXTERNAL_ASSESMENT') {
      setInterviewMode('EXTERNAL_LINK')
    }
  }

  useEffect(() => {
    getMode()
  }, [driveData, interviewType])

  useEffect(() => {
    form.setFieldsValue({
      mode: interviewMode,
    })
  }, [interviewMode])

  useEffect(() => {
    form.setFieldsValue({
      candidatesPerGroup: candidates,
    })
  }, [candidates])

  useEffect(() => {
    if (!preview) {
      setInterviewType(selectedRoundType?.type)
      form.setFieldsValue({
        interviewType: selectedRoundType?.type,
      })
    }
  }, [selectedRoundType, scheduleDrawer])

  useEffect(() => {
    setInterviewList(interviewListData)
  }, [interviewListData])

  const onSubmitFormData = async values => {
    const dates =
      values?.interviewType === 'ASSESMENT'
        ? [
            moment(values?.startDate).format('YYYY-MM-DD'),
            moment(values?.endDate).format('YYYY-MM-DD'),
          ]
        : [
            moment(dateRange[0], 'DD/MM/YYYY').format('YYYY-MM-DD'),
            moment(dateRange[1], 'DD/MM/YYYY').format('YYYY-MM-DD'),
          ]

    if (
      interviewType === 'ASSESMENT' ||
      interviewType === 'EXTERNAL_ASSESMENT'
    ) {
      setInterviewInfo({ ...values, dates: dates })
      handlePreview()
    } else {
      setInterviewInfo({ ...values, dates: dates })
      scheduleInterview(false, { ...values, dates: dates })
    }
    setInterviewdate(values)
  }

  const getLinkAndPanelValue = value => {
    let updatedList = []
    if (interviewMode === 'OFFLINE') {
      updatedList = value.map(({ panel }) => {
        return { panel: panel }
      })
    } else if (
      (interviewType === 'ASSESMENT' ||
        interviewType === 'EXTERNAL_ASSESMENT') &&
      interviewMode === 'EXTERNAL_LINK'
    ) {
      updatedList = value.map(({ link }) => {
        return {
          link: link,
          panel: [{ id: null, firstName: null, lastName: null }],
        }
      })
    } else {
      updatedList = value
    }

    return updatedList
  }

  const typeLabels = {
    ASSESMENT: 'Assessment',
    GROUP: 'Group Discussion',
    FACE_TO_FACE: 'Interview',
    EXTERNAL_ASSESMENT: 'External Assessment',
  }
  const labelText = typeLabels[selectedRoundType?.type] || ''
  const messageType = toCamelCase(labelText)

  const scheduleInterview = async (isConfirm, values) => {
    const dates =
      values?.interviewType === 'ASSESMENT' ||
      values?.interviewType === 'EXTERNAL_ASSESMENT'
        ? [
            moment(values?.startDate).format('YYYY-MM-DD'),
            moment(values?.endDate).format('YYYY-MM-DD'),
          ]
        : [
            moment(dateRange[0], 'DD/MM/YYYY').format('YYYY-MM-DD'),
            moment(dateRange[1], 'DD/MM/YYYY').format('YYYY-MM-DD'),
          ]

    setIsLoading(true)
    let isBulk =
      selectedCandidate?.length === 10 ||
      selectedCandidate?.length === candidateDeatils?.candidateList?.count
    const feedback = parametersList?.map(item => {
      return {
        qp: 0,
        type: item,
        value: 0,
      }
    })
    let payload = {
      ...values,
      forAllCandidate: isBulk,
      isconfirmed: isConfirm,
      candidatesPerGroup:
        interviewType !== 'GROUP' ? 1 : values?.candidatesPerGroup,

      dates: dates,
      studentIds: isSingleOrBulk
        ? selectedCandidate.map(data => {
            return { studentId: data?.student?.id }
          })
        : [{ studentId: selectedCandidateId[0] }],
      linkAndPanel: getLinkAndPanelValue(values?.linkAndPanel),
      time:
        (interviewType === 'ASSESMENT' ||
          interviewType === 'EXTERNAL_ASSESMENT') &&
        interviewMode === 'EXTERNAL_LINK'
          ? '00:00:00'
          : values.time,
      mode: values?.mode?.includes('EXTERNAL_LINK')
        ? 'EXTERNAL_LINK'
        : values?.mode,
      feedback:
        interviewType != 'ASSESMENT' || interviewType != 'EXTERNAL_ASSESMENT'
          ? feedback
          : [],
    }

    let response = await createInterview(driveId, roleId, payload)
    if (response?.status >= 200 && response?.status <= 300) {
      setIsLoading(false)
      if (isConfirm) {
        SuccessMessage(`${messageType} scheduled successfully!`)
        setScheduleDrawer(false)
        form.resetFields()
        setInterviewInfo({})
        form.setFieldsValue({ interviewRound: selectedRoundName })
        form.setFieldsValue({ mode: interviewMode })
        getCandidateList()
        getRoleMetrics(driveId, roleId)
        setSelectedCandidateId([])
        setSelectedCandidate([])
        setSelectingStartDate('')
        setSelectingEndDate('')
        setDateRange([])
        setLinkPanelData([
          {
            link: '',
            panel: [{ id: null, firstName: null, lastName: null }],
          },
        ])
        form.setFieldsValue({
          mode: interviewMode,
        })

        if (
          scheduleTemplate &&
          (interviewType === 'ASSESMENT' ||
            interviewType === 'EXTERNAL_ASSESMENT') &&
          interviewMode === 'EXTERNAL_LINK'
        ) {
          const final = selectedCandidate?.map(item => {
            const template = scheduleTemplate?.templateText
              .replace('{companyName}', corporateData?.name)
              .replace('{roleName}', rolesMetrics[0]?.roleName)
              .replace('{startDate}', moment(dates[0]).format('DD/MMM/YYYY'))
              .replace('{endDate}', moment(dates[1]).format('DD/MMM/YYYY'))
              .replace('{duration}', payload?.duration + ` Mins`)
              .replace(
                '{link}',
                payload?.linkAndPanel?.[0]?.link
                  ? payload?.linkAndPanel?.[0]?.link
                  : AUTH_URL
              )
            return {
              to: isSingleOrBulk
                ? item?.student?.studentPersonalProfile?.primaryEmail
                : item?.studentPersonalProfile?.primaryEmail,
              subject: scheduleTemplate?.subject,
              htmlBody: template,
            }
          })
          dispatch(sendNotificationBulkEmail(final))
        }
        if (
          scheduleOfflineTemplate &&
          interviewType === 'ASSESMENT' &&
          interviewMode != 'EXTERNAL_LINK'
        ) {
          const final = selectedCandidate?.map(item => {
            const template = scheduleOfflineTemplate?.templateText
              .replace('{companyName}', corporateData?.name)
              .replace('{roleName}', rolesMetrics[0]?.roleName)
              .replace('{startDate}', moment(dates[0]).format('DD/MMM/YYYY'))
              .replace('{endDate}', moment(dates[1]).format('DD/MMM/YYYY'))
              .replace('{duration}', payload?.duration + ` Mins`)
              .replace('{location}', payload?.location)
            return {
              to: isSingleOrBulk
                ? item?.student?.studentPersonalProfile?.primaryEmail
                : item?.studentPersonalProfile?.primaryEmail,
              subject: scheduleOfflineTemplate?.subject,
              htmlBody: template,
            }
          })
          dispatch(sendNotificationBulkEmail(final))
        }
        if (interviewTemplate && interviewType != 'ASSESMENT') {
          const final = selectedCandidate?.map(item => {
            const template = interviewTemplate?.templateText
              .replace('{companyName}', corporateData?.name)
              .replace('{roleName}', rolesMetrics[0]?.roleName)
              .replace('{date}', moment(dates[0]).format('DD/MMM/YYYY'))
              .replace('{duration}', payload?.duration + ` Mins`)
              .replace('{location}', payload?.location)
            return {
              to: isSingleOrBulk
                ? item?.student?.studentPersonalProfile?.primaryEmail
                : item?.studentPersonalProfile?.primaryEmail,
              subject: interviewTemplate?.subject,
              htmlBody: template,
            }
          })
          dispatch(sendNotificationBulkEmail(final))
        }

        if (
          assessmentWhatsapp &&
          (interviewType === 'ASSESMENT' ||
            interviewType === 'EXTERNAL_ASSESMENT') &&
          interviewMode === 'EXTERNAL_LINK'
        ) {
          const final = selectedCandidate?.map(item => {
            return {
              to: isSingleOrBulk
                ? item?.student?.studentPersonalProfile?.phoneNumber
                : item?.studentPersonalProfile?.phoneNumber,
              templateName: assessmentWhatsapp?.templateName,
              components: [
                {
                  type: 'BODY',
                  index: 0,
                  sub_type: 'CATALOG',
                  parameters: [
                    {
                      type: 'TEXT',
                      text: isSingleOrBulk
                        ? item?.student?.firstName
                        : item?.firstName,
                    },
                    {
                      type: 'TEXT',
                      text: rolesMetrics[0]?.roleName,
                    },
                    {
                      type: 'TEXT',
                      text: corporateData?.name,
                    },
                    {
                      type: 'TEXT',
                      text: `  ` + moment(dates[0]).format('DD/MMM/YYYY'),
                    },
                    {
                      type: 'TEXT',
                      text: `  ` + moment(dates[1]).format('DD/MMM/YYYY'),
                    },
                    {
                      type: 'TEXT',
                      text: `  ` + payload?.duration + ` Mins`,
                    },
                    {
                      type: 'TEXT',
                      text:
                        `  ` + payload?.linkAndPanel?.[0]?.link
                          ? payload?.linkAndPanel?.[0]?.link
                          : AUTH_URL,
                    },
                  ],
                },
              ],
            }
          })
          dispatch(sendAssessmentWhatsapp(final))
        }

        if (
          assessmentOfflineWhatsapp &&
          interviewType === 'ASSESMENT' &&
          interviewMode != 'EXTERNAL_LINK'
        ) {
          const final = selectedCandidate?.map(item => {
            return {
              to: isSingleOrBulk
                ? item?.student?.studentPersonalProfile?.phoneNumber
                : item?.studentPersonalProfile?.phoneNumber,
              templateName: assessmentOfflineWhatsapp?.templateName,
              components: [
                {
                  type: 'BODY',
                  index: 0,
                  sub_type: 'CATALOG',
                  parameters: [
                    {
                      type: 'TEXT',
                      text: isSingleOrBulk
                        ? `  ` + item?.student?.firstName
                        : `  ` + item?.firstName,
                    },
                    {
                      type: 'TEXT',
                      text: `  ` + rolesMetrics[0]?.roleName,
                    },
                    {
                      type: 'TEXT',
                      text: `  ` + corporateData?.name,
                    },
                    {
                      type: 'TEXT',
                      text: `  ` + moment(dates[0]).format('DD/MMM/YYYY'),
                    },
                    {
                      type: 'TEXT',
                      text: `  ` + moment(dates[1]).format('DD/MMM/YYYY'),
                    },
                    {
                      type: 'TEXT',
                      text: `  ` + payload?.duration + ` Mins`,
                    },
                    {
                      type: 'TEXT',
                      text: payload?.location,
                    },
                  ],
                },
              ],
            }
          })
          dispatch(sendAssessmentWhatsapp(final))
        }

        if (
          interviewVirtualWhatsapp &&
          interviewType != 'ASSESMENT' &&
          interviewMode === 'EXTERNAL_LINK'
        ) {
          const final = selectedCandidate?.map(item => {
            return {
              to: isSingleOrBulk
                ? item?.student?.studentPersonalProfile?.phoneNumber
                : item?.studentPersonalProfile?.phoneNumber,
              templateName: 'interview_scheduled__virtual_',
              components: [
                {
                  type: 'BODY',
                  index: 0,
                  sub_type: 'CATALOG',
                  parameters: [
                    {
                      type: 'TEXT',
                      text: isSingleOrBulk
                        ? item?.student?.firstName
                        : item?.firstName,
                    },
                    {
                      type: 'TEXT',
                      text: rolesMetrics[0]?.roleName,
                    },
                    {
                      type: 'TEXT',
                      text: corporateData?.name,
                    },
                    {
                      type: 'TEXT',
                      text: ` ` + moment(dates[0]).format('DD/MMM/YYYY'),
                    },
                    {
                      type: 'TEXT',
                      text: ` ` + payload?.time,
                    },
                    {
                      type: 'TEXT',
                      text: ` ` + payload?.duration + ` Mins`,
                    },
                    {
                      type: 'TEXT',
                      text: payload?.linkAndPanel?.[0]?.link
                        ? payload?.linkAndPanel?.[0]?.link
                        : AUTH_URL,
                    },
                  ],
                },
              ],
            }
          })
          dispatch(sendNotificationBulkEmailWhatsapp(final))
        }

        if (
          interviewCampusWhatsapp &&
          interviewType != 'ASSESMENT' &&
          interviewMode != 'EXTERNAL_LINK'
        ) {
          const final = selectedCandidate?.map(item => {
            return {
              to: isSingleOrBulk
                ? item?.student?.studentPersonalProfile?.phoneNumber
                : item?.studentPersonalProfile?.phoneNumber,
              templateName: 'interview_scheduled__campus_and_pool_drive',
              components: [
                {
                  type: 'BODY',
                  index: 0,
                  sub_type: 'CATALOG',
                  parameters: [
                    {
                      type: 'TEXT',
                      text: isSingleOrBulk
                        ? item?.student?.firstName
                        : item?.firstName,
                    },
                    {
                      type: 'TEXT',
                      text: rolesMetrics[0]?.roleName,
                    },
                    {
                      type: 'TEXT',
                      text: corporateData?.name,
                    },
                    {
                      type: 'TEXT',
                      text: ` ` + moment(dates[0]).format('DD/MMM/YYYY'),
                    },
                    {
                      type: 'TEXT',
                      text: ` ` + payload?.duration + ` Mins`,
                    },
                    {
                      type: 'TEXT',
                      text: ` ` + payload?.location,
                    },
                  ],
                },
              ],
            }
          })
          dispatch(sendNotificationBulkEmailWhatsapp(final))
        }
      } else {
        handlePreview()
        setConfirmedResponse(response?.data?.data)
      }
      getMode()
      return true
    } else {
      setIsLoading(false)
      ErrorMessage(response?.response?.data?.message)
      return false
    }
  }

  const content = () => {
    return (
      <InterviewForm
        form={form}
        selectedCandidate={selectedCandidate}
        rolesMetrics={rolesMetrics}
        driveInterViewerList={driveInterViewerList}
        driveData={driveData}
        candidateDeatils={candidateDeatils}
        SelectedRoundName={selectedRoundName}
        interviewMode={interviewMode}
        isOneDayDrive={isOneDayDrive}
        linkPanelData={linkPanelData}
        setLinkPanelData={setLinkPanelData}
        addedInterviewer={addedInterviewer}
        interviewInfo={interviewInfo}
        isSingleOrBulk={isSingleOrBulk}
        handleIterviewRound={handleIterviewRound}
        disabledDate={disabledDate}
        onChangeDate={onChangeDate}
        onDurationChange={onDurationChange}
        onTimeChange={onTimeChange}
        onChangeMode={onChangeMode}
        onChangeLink={onChangeLink}
        onClickNone={onClickNone}
        onSelectInterview={onSelectInterview}
        onSubmitFormData={onSubmitFormData}
        interviewType={interviewType}
        dateFormat={dateFormat}
        candidates={candidates}
        setCandidates={setCandidates}
        selectedRoundType={selectedRoundType}
        preview={preview}
        disabledStartDate={disabledStartDate}
        disabledEndDate={disabledEndDate}
        onChangeStartDate={onChangeStartDate}
        onChangeEndDate={onChangeEndDate}
        selectingStartDate={selectingStartDate}
        selectingEndDate={selectingEndDate}
        isAssesemntType={isAssesemntType}
        dateRange={dateRange}
        interviewList={interviewList}
        getUpdatedList={getUpdatedList}
        isBulk={
          selectedCandidate?.length === 10 ||
          selectedCandidate?.length === candidateDeatils?.candidateList?.count
        }
        parametersList={parametersList}
        setParametersList={setParametersList}
      />
    )
  }

  const footer = () => {
    return (
      <FooterFlex flexEnd>
        <Button.Secondary
          onClick={() => {
            setPreview(false)
            setScheduleDrawer(false)
            form.resetFields()
            setInterviewInfo({})
            form.setFieldsValue({ interviewRound: selectedRoundName })
            form.setFieldsValue({ mode: null })
            setSelectingStartDate('')
            setSelectingEndDate('')
            setDateRange([])

            setLinkPanelData([
              {
                link: '',
                panel: [{ id: null, firstName: null, lastName: null }],
              },
            ])
          }}
          width="88px"
          height="38px"
          text="Cancel"
        />

        <Button.Primary
          height="38px"
          text={'Preview & Schedule'}
          form={'scheduleForm'}
          htmlType={'submit'}
          loading={isLoading}
        />
      </FooterFlex>
    )
  }

  return (
    <>
      <Drawer
        width="43%"
        title={'Schedule'}
        placement="right"
        visible={scheduleDrawer}
        content={content()}
        footer={footer()}
        onClose={() => {
          setPreview(false)
          setScheduleDrawer(false)
          form.resetFields()
          setInterviewInfo({})
          form.setFieldsValue({ interviewRound: selectedRoundName })
          form.setFieldsValue({ mode: null })
          setSelectingStartDate('')
          setSelectingEndDate('')
          setDateRange([])
          setLinkPanelData([
            {
              link: '',
              panel: [{ id: null, firstName: null, lastName: null }],
            },
          ])
          form.setFieldsValue({
            mode: null,
          })
        }}
        closable
      />
      {schedulePreview && (
        <ManyToManyPreview
          schedulePreview={schedulePreview}
          setSchedulePreview={setSchedulePreview}
          confirmedResponse={confirmedResponse}
          interviewType={interviewType}
          setScheduleDrawer={setScheduleDrawer}
          setPrivew={setPreview}
        />
      )}
      {preview && (
        <OneToOnePreview
          interviewType={interviewType}
          interviewInfo={interviewInfo}
          driveInterViewerList={driveInterViewerList}
          isSingleOrBulk={isSingleOrBulk}
          selectedCandidate={selectedCandidate}
          setScheduleDrawer={setScheduleDrawer}
          setPrivew={setPreview}
          scheduleInterview={scheduleInterview}
          preview={preview}
          isOneDayDrive={isOneDayDrive}
          setInterviewType={setInterviewType}
          isLoading={isLoading}
          candidateInfoData={candidateInfoData}
          confirmedResponse={confirmedResponse}
          count={candidateDeatils?.candidateList?.count}
          isBulk={
            selectedCandidate?.length === 10 ||
            selectedCandidate?.length === candidateDeatils?.candidateList?.count
          }
          interviewdate={interviewdate}
          selectedRoundType={selectedRoundType}
        />
      )}
    </>
  )
}

export default ScheduleInterview
